import isUndefinedNullOrEmpty from "./isUndefinedNullOrEmpty";

const undefinedIfEmpty = (value: any) => ( isUndefinedNullOrEmpty(value) ? undefined : value );

export default undefinedIfEmpty;
